module.exports = __webpack_public_path__ + "static/img/icon_help.4382e37f.png";